import {PropsWithChildren} from 'react'
import './styles.css'

export default function ButtonGroup({children}: PropsWithChildren) {
  return <div className='ButtonGroupWrapper'>{children}</div>
}
